import { useTheme } from "../../../theme/ThemeProvider";
import { ITheme } from "../../../theme/ITheme";
import { ISearchStyles } from "../../styles";

export const useSearchStyles = (theme?: ITheme): ISearchStyles => {
    if (theme === undefined) {
        theme = useTheme();
    }

    return {
        clearButton: {
            backgroundColor: theme.palette.accent.dark,
            border: `1px solid ${theme.palette.accent.dark}`,
            color: theme.palette.white,
        },
        newButton: {
            backgroundColor: theme.palette.background.main,
            border: `1px solid ${theme.palette.accent.dark}`,
            color: theme.palette.accent.dark,
        },
        searchButton: {
            backgroundColor: theme.palette.accent.dark,
            border: `1px solid ${theme.palette.accent.dark}`,
            color: theme.palette.white,
        },
        icon: {
            fontSize: 18,
        },
        button: {
            fontSize: 16,
            height: 40,
            borderRadius: theme.shape.borderRadiusSm,
            verticalAlign: "middle",
        },
        searchContainer: {
            marginBottom: theme.spaceUnits.sp04,
            paddingLeft: theme.spaceUnits.sp01,
            paddingRight: theme.spaceUnits.sp01
        },
    };
};